// src/pages/QysList.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function QysList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const cargarQys = async () => {
      try {
        setLoading(true);
        setError("");

        const qRef = query(
          collection(db, "qys"),
          orderBy("fechaCreacion", "desc") // si te pide índice lo puedes quitar
        );

        const snap = await getDocs(qRef);
        const lista = snap.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            userId: data.userId || "",
            titulo: data.titulo || "",
            mensaje: data.mensaje || "",
            fechaCreacion: data.fechaCreacion?.toDate?.() || null,
          };
        });

        setItems(lista);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    cargarQys();
  }, []);

  const handleOpenDetail = (item) => {
    navigate(`/qys/${item.id}`);
  };

  if (loading) return <p>Cargando quejas y sugerencias...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <h1>Quejas y sugerencias</h1>
      <p style={{ marginBottom: 16 }}>Total: {items.length}</p>

      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 14,
          }}
        >
          <thead>
            <tr>
              <th style={th}>Fecha</th>
              <th style={th}>Título</th>
              <th style={th}>Mensaje</th>
              <th style={th}>Usuario</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
                <tr
                key={item.id}
                style={{
                    cursor: "pointer",
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#e9e9e9", // ⬅️ zebra

                }}
                onClick={() => handleOpenDetail(item)}
                >
                <td style={td}>
                    {item.fechaCreacion
                    ? item.fechaCreacion.toLocaleString()
                    : "-"}
                </td>
                <td style={{ ...td, ...clamp2, maxWidth: 220 }}>
                    {item.titulo || "(sin título)"}
                </td>
                <td style={{ ...td, ...clamp2, maxWidth: 360 }}>
                    {item.mensaje || "(sin mensaje)"}
                </td>
                <td style={td}>{item.userId}</td>
                </tr>
            ))}
</tbody>

        </table>
      </div>
    </div>
  );
}

const th = {
  borderBottom: "1px solid #ddd",
  textAlign: "left",
  padding: "8px",
  backgroundColor: "#f5f5f5",
};

const td = {
  borderBottom: "1px solid #eee",
  padding: "8px",
};

const clamp2 = {
  display: "-webkit-box",
  WebkitLineClamp: 2, // máximo 2 líneas
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};
